<template>
  <div class="colorlib-pricing">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-md-offset-2 text-center colorlib-heading animate-box">
          <h1 :is="isMain ? 'h1' : 'h2'">
            {{ $tc('plan.label', 2) }}
            <i class="icon-circle-compass"></i>
          </h1>
          <p>{{ $tc('site.plans.subtitle', 2) }}</p>
        </div>
      </div>

      <div class="d-flex justify-content-center row">
        <div class="col-md-3 text-center animate-box">
          <div class="pricing">
            <h2 class="pricing-heading">Free</h2>
            <div data-v-35efae92 plan.base_value>
              <p data-v-35efae92 class="hand mt-3">{{ $tc('n_user.label', 1, {n: 1}) }}</p>
              <p data-v-35efae92 class="hand mt-3">
                {{ $tc('process', 2) }}:
                100
              </p>
              <p data-v-35efae92 class="hand">
                {{ $tc('profile', 2) }}:
                100
              </p>
              <p data-v-35efae92>
                {{ $tc('storage', 1) }}
                10 Mb
              </p>
              <p>
                <router-link :to="{ name: 'create_account'}" class="btn btn-primary">
                  {{ $t('site.register.btn_create_your_account') }}
                  <i class="icon-circle-check"></i>
                </router-link>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-3 text-center animate-box">
          <div class="pricing">
            <h2 class="pricing-heading">Professional</h2>
            <div class="price">
              <currency-factor :value="3.5">
                <small class="period">{{ $tc('user.label', 1) }}/{{ $tc('date.month.label', 1) }}</small>
              </currency-factor>
            </div>

            <div>
              <p data-v-35efae92 class="hand mt-3">
                {{ $tc('process', 2) }}:
                {{ $tc('unlimited', 2) }}
              </p>
              <p data-v-35efae92 class="hand">
                {{ $tc('profile', 2) }}:
                {{ $tc('unlimited', 2) }}
              </p>
              <p data-v-35efae92>
                {{ $tc('storage', 1) }}:<br>
                500 Mb<small> x {{ $tc('user.label', 2) }}</small>
              </p>
              <p
                data-v-35efae92
                class="m-pricingCard1__afterPrice mt-3 font-weight-bold"
              >{{ $tc('message.month_free', 2, {n: 7}) }}</p>
              <p>
                <router-link :to="{ name: 'create_account'}" class="btn btn-primary">
                  {{ $t('site.register.btn_create_your_account') }}
                  <i class="icon-circle-check"></i>
                </router-link>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-3 text-center animate-box">
          <div class="pricing">
            <h2 class="pricing-heading">My System</h2>

            <div data-v-35efae92 class="mt-2">
              <p data-v-35efae92>{{ $t('plan.use_your_domain.label') }}</p>
              <p data-v-35efae92>{{ $t('plan.your_logo.label') }}</p>
              <p data-v-35efae92>{{ $t('plan.use_your_email.label') }}</p>
              <p data-v-35efae92>{{ $t('plan.custom_theme.label') }}</p>
              <p data-v-35efae92>{{ $t('plan.custom_features.label') }}</p>
              <p data-v-35efae92 class="hand mt-3">
                {{ $tc('process', 2) }}:
                {{ $tc('unlimited', 2) }}
              </p>
              <p data-v-35efae92 class="hand">
                {{ $tc('profile', 2) }}:
                {{ $tc('unlimited', 2) }}
              </p>
              <p data-v-35efae92>
                {{ $tc('storage', 1) }}:
                {{ $tc('unlimited', 1) }}
              </p>
              <p
                data-v-35efae92
                class="m-pricingCard1__afterPrice mt-3 font-weight-bold"
              >{{ $tc('message.month_free', 2, {n: 7}) }}</p>
              <p>
                <router-link :to="{ name: 'contact'}" class="btn btn-info">
                  {{ $t('contact.request_contact') }}
                  <i class="icon-paperplane ml-1"></i>
                </router-link>
              </p>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-3 text-center animate-box">
					<div class="pricing">
						<h2 class="pricing-heading">Unlimited</h2>
						<div class="price"><sup class="currency">$</sup>140<small>per month</small></div>
						<p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>
						<p><a href="#" class="btn btn-primary">Select Plan</a></p>
					</div>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CurrencyFactor from "@/components/AccountPlans/CurrencyFactor";

export default {
  name: "AppTemplate",
  components: {
    CurrencyFactor
  },
  props: {
    isMain: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    ...mapState("apps", ["filters"]),
    // ...mapState("category", ["categories"]),
    selectedCategoryId() {
      return this.filters.category_id;
    }
  },
  mounted() {
    // this.getCategories();
    // eslint-disable-next-line
    // ga("set", "page", "/plans.html");
    // eslint-disable-next-line
    // ga("send", "pageview", "/plans");
  },
  methods: {
    // ...mapActions("apps", ["setFilterCategoryId"]),
    // ...mapActions("category", ["getCategories"]),
    // changeCategory(id) {
    //   this.setFilterCategoryId({ id: id });
    //   console.log(id);
    // }
  }
};
</script>

<style scoped>
.pricing {
  border: 1px solid rgb(214, 214, 214);
  margin-bottom: 10px;
}

.pricing .price small {
	font-size: 13px;
	display: block;
	color: rgb(104, 104, 104); 
}

</style>